import { ActivityLevelValidation } from '@/api/EmissionReportModel'
import { UnitLabel } from '@/shared/config/config'
import useI18n from '@/shared/hooks/useI18n'
import { DataBlock } from '@/common'

export default function ActivityLevelValidationReporting({
  activitiyLevelValidation,
  activityLevel,
  precursorAmmountInTonnes,
  preConsumerScrapAmmountInTonnes,
  otherMaterialsAmmountInTonnes
}: {
  activityLevel: number
  activitiyLevelValidation: ActivityLevelValidation | null
  precursorAmmountInTonnes: number
  preConsumerScrapAmmountInTonnes: number
  otherMaterialsAmmountInTonnes: number
}) {
  const { numberFormatter2Decimals } = useI18n()
  const { t } = useI18n()
  const input =
    precursorAmmountInTonnes + preConsumerScrapAmmountInTonnes + otherMaterialsAmmountInTonnes

  const conversions = activitiyLevelValidation?.conversions
  const conversionsPercentage = activitiyLevelValidation?.conversionsPercentage
  const waste = activitiyLevelValidation?.waste
  const changeInStock = activitiyLevelValidation?.changeInStock
  return (
    <div>
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2">
        <DataBlock
          label={t('report:activityLevelValidation.dataBlocks.input.label')}
          data={`${input} ${UnitLabel.t}`}
        />
        <DataBlock
          label={t('report:activityLevelValidation.dataBlocks.activityLevel.label')}
          data={`${activityLevel} ${UnitLabel.t}`}
        />
        <DataBlock
          label={t('report:activityLevelValidation.dataBlocks.changeInStock.label')}
          data={`${changeInStock} ${UnitLabel.t}`}
        />
        <DataBlock
          label={t('report:activityLevelValidation.dataBlocks.waste.label')}
          data={`${waste} ${UnitLabel.t}`}
        />
        <DataBlock
          label={t('report:activityLevelValidation.dataBlocks.conversions.label')}
          data={
            <>
              {conversions || 0} {UnitLabel.t} (
              {numberFormatter2Decimals(conversionsPercentage || 0)} %)
            </>
          }
          tooltip={t('report:activityLevelValidation.dataBlocks.conversions.tooltip')}
        />
      </div>
    </div>
  )
}
